<template>
  <div>
    <epi-modal :opening-event-name="openingEventName" title="새로운 예약">
      <template v-slot:offcanvas>
        <customer-add-offcanvas />
      </template>
      <template v-slot:header-menu>
        <button class="btn btn-light">기타</button>

        <div class="dropdown">
          <button
            class="btn btn-light dropdown-toggle"
            data-bs-toggle="dropdown"
          >
            <color-badge :color="color" />
            색상
          </button>
          <ul class="dropdown-menu">
            <li v-for="c in colors" :key="c" @click="clickColor(c)">
              <a href="javascript:0" class="dropdown-item text-black-50">
                <color-badge :color="c" />
                {{ c }}
              </a>
            </li>
          </ul>
        </div>
      </template>
      <template v-slot:body>
        <div class="d-flex gap-1">
          <epi-select
            v-model="name"
            :candidates="['가나다', '마바사']"
            placeholder="고객명"
            class="flex-grow-1"
          />

          <button
            class="btn btn-primary flex-grow-1"
            @click="openCustomerAddOffcanvas"
          >
            신규 고객
          </button>
        </div>
<div class="row">
          <div class="col-8 pe-0">
            <label class="form-label">프로그램</label>
            <epi-multi-select
              v-model="selectedMeetingTypes"
              :candidates="meetingTypes"
            />
          </div>
          <div class="col-4">
            <label class="form-label">비용(원)</label>
            <input type="number" class="form-control" placeholder="0" />
          </div>
        </div>
        <div class="d-flex flex-column flex-md-row gap-2">
          <div class="flex-fill">
            <label>날짜</label>
            <epi-date-picker />
          </div>
          <div class="flex-fill">
            <label>시작 시간</label>
            <input type="time" class="form-control" />
          </div>
          <div class="flex-fill">
            <label>진행 시간(분)</label>
            <input type="number" class="form-control" placeholder="50" />
          </div>
        </div>

        <div class="d-flex align-items-center">
          <label class="me-3">장소</label>

          <epi-select
            v-model="selectedPlaceType"
            :candidates="placeTypes"
            placeholder="장소"
            class="flex-fill"
          />
        </div>

        <template v-if="selectedPlaceType === placeInPerson">
          <div class="d-flex">
            <div class="input-group">
              <i class="bi bi-geo-alt input-group-text"></i>
              <input
                type="text"
                class="form-control"
                placeholder="장소"
                v-model="place"
              />
            </div>
          </div>
        </template>

        <template v-if="selectedPlaceType === placeRemote">
          <div class="d-flex">
            <div class="input-group has-validation has-validation">
              <i class="bi bi-link input-group-text"></i>
              <input
                type="text"
                class="form-control"
                :class="{ 'is-invalid': isInvalidLink }"
                placeholder="화상상담링크"
                v-model="link"
              />
              <div class="invalid-feedback">올바른 링크를 입력해주세요</div>
            </div>
          </div>
        </template>

        <div class="d-flex">
          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="recurrent"
              />
              반복</label
            >
          </div>

          <div class="form-check mx-4">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="recurrent"
              />
              이용권</label
            >
          </div>

          <div class="form-check">
            <label class="form-check-label">
              <input
                type="checkbox"
                class="form-check-input"
                v-model="recurrent"
              />
              바우처</label
            >
          </div>
        </div>

        <template v-if="recurrent">
          <div class="hstack gap-2">
            <epi-select
              v-model="recurrence"
              :candidates="[every1Week, everyCoupleOfWeeks]"
            />
            <epi-select
              v-model="numOfRecurrence"
              :candidates="recurrenceArr"
              class="d-inline-flex "
            />
            <label class="flex-grow-1">번 반복</label>
            
          </div>
        </template>

        <div class="d-flex align-items-center">
          <label class="me-3">결제방법</label>
          <epi-select placeholder="이용권" class="flex-fill" />
        </div>

        <div class="row">
          <div class="col-8 pe-0">
            <label class="form-label">이용권</label>
            <epi-select placeholder="888" class="flex-fill" />
          </div>
          <div class="col-4">
            <label class="form-label">잔여 횟수</label>
            <input type="number" class="form-control" placeholder="1" />
          </div>
        </div>

        
        <div>
        <label class="form-label">상담사 메모</label>
        <input type="text" class="form-control" placeholder="메모(상담사 메모)" />
        </div>
        <hr class="my-0 py-0" />
        <div>
        <label class="form-label">고객에게 남길 메모</label>
        <input type="text" class="form-control" placeholder="메모(고객에게 남길 메모)" />
        </div>
      </template>
      <template v-slot:footer>
        <div class="d-flex w-100 justify-content-between align-items-center">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox" class="form-check-input" />
              즉시 알림 전송</label
            >
          </div>
          <div class="hstack gap-2">
            <button class="btn btn-dark" data-bs-dismiss="modal">취소</button>
            <button class="btn btn-light">확인</button>
          </div>
        </div>
      </template>
    </epi-modal>
  </div>
</template>

<script>
import { Color, EventName } from "@/const";

const placeInPerson = "대면";
const placeRemote = "화상";
const every1Week = "일주일에 한 번";
const everyCoupleOfWeeks = "격주에 한 번";

export default {
  name: "EventAddModal",
  data() {
    return {
      modal: null,
      placeTypes: [placeInPerson, placeRemote],
      placeInPerson,
      placeRemote,
      selectedPlaceType: null,
      place: "",
      link: "",
      recurrent: true,
      every1Week,
      everyCoupleOfWeeks,
      recurrence: every1Week,
      numOfRecurrence: 10,
      recurrenceArr: [],
      notiOnTheFly: false,
      colors: Object.keys(Color),
      color: Object.keys(Color)[0],
      openingEventName: EventName.EventAddModalOpening,
      name: null,
      meetingTypes: ["개인상담", "집단상담"],
      selectedMeetingTypes: [],
    };
  },
  computed: {
    isInvalidLink() {
      if (this.link.trim() === "") return false;

      // link validation
      if (!this.link.startsWith("http")) return true;
      return false;
    },
  },
  methods: {
    clickColor(c) {
      this.color = c;
    },
    openCustomerAddOffcanvas() {
      this.$root.$emit(EventName.CustomerAddOffcanvasOpening);
    },
  },
  mounted() {
    for (let i = 2; i <= 30; i++) this.recurrenceArr.push(i);
  },
};
</script>
